import React from 'react';
import PropTypes from 'prop-types';
import { Loader } from 'kangarootime-ui';
import TableHeader from '../../shared/TableHeader';
import ClocksTableCell from '../../shared/ClocksTableCell';
import LocationCoordinateTableCell from '../../shared/LocationCoordinateTableCell';
import moment from 'moment';
import '../../shared/TimecardsTable.css';

const RangeTimecardsTable = ({
  timecards,
  fetchingTimecards,
  setEditsToTimecard,
  clockEditsById,
  ...props
}) => {
  return (
    <table className='timecards-table'>
      <TableHeader columns={['Date', 'Clock In', 'Clock In Location', 'Clock Out', 'Clock Out Location']} />
      <Loader loading={fetchingTimecards}>
        <tbody>
          {timecards.length === 0
            ? <tr className='timecards-table-row timecards-table-employee-row'>
              <td>
                <span className='timecards-table-employee-row-text'>No timecards found in this timeframe.</span>
              </td>
              <td />
              <td />
              <td />
              <td />
            </tr>
            : timecards.map(timecard => {
              const { timecard_id: timecardId, start } = timecard;

              return (
                <tr
                  key={timecardId}
                  className='timecards-table-row timecards-table-employee-row'
                >
                  <td>
                    <span className='timecards-table-employee-row-text'>{moment(start).format('MMM Do, YYYY')}</span>
                  </td>
                  <ClocksTableCell
                    timecards={[timecard]}
                    direction='in'
                    as='input'
                    setEditsToTimecard={setEditsToTimecard}
                    clockEditsById={clockEditsById}
                  />
                  <LocationCoordinateTableCell
                    timecards={[timecard]}
                    direction='in'
                  />
                  <ClocksTableCell
                    timecards={[timecard]}
                    direction='out'
                    as='input'
                    setEditsToTimecard={setEditsToTimecard}
                    clockEditsById={clockEditsById}
                  />
                  <LocationCoordinateTableCell
                    timecards={[timecard]}
                    direction='out'
                  />
                </tr>
              );
            })}
        </tbody>
      </Loader>
    </table>
  );
};

RangeTimecardsTable.propTypes = {
  timecards: PropTypes.arrayOf(PropTypes.object),
  fetchingTimecards: PropTypes.bool,
  setEditsToTimecard: PropTypes.func,
  clockEditsById: PropTypes.object
};

export default RangeTimecardsTable;
